import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { DataService } from './data.service';
import { DialogService } from './dialog.service';
import { OrderDetailsNew } from '../models/order.models';

@Injectable({ providedIn: 'root' })
export class TaskCrudService {

  constructor(
    private dataService: DataService,
    private dialogService: DialogService,
    private router: Router,
    private location: Location
  ) {}

  getTypesFromBackend(onSuccess: (types: any[]) => void): void {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.get('/tasks/types').subscribe({
      next: (response: any) => {
        onSuccess(response);
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err: any) => {
        this.dialogService.handleError(err, 'Failed to get Types information, Please try again.')
          .subscribe(() => this.location.back());
      }
    });
  }

  getSubTypesFromBackend(onSuccess: (subTypes: any[]) => void): void {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.get('/tasks/sub-types').subscribe({
      next: (response: any) => {
        onSuccess(response);
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err: any) => {
        this.dialogService.handleError(err, 'Failed to get Sub Types information, Please try again.')
          .subscribe(() => this.location.back());
      }
    });
  }

  getPropsFromBackend(onSuccess: (props: any[]) => void): void {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.get('/tasks/props').subscribe({
      next: (response: any) => {
        onSuccess(response);
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err: any) => {
        this.dialogService.handleError(err, 'Failed to get Properties information, Please try again.')
          .subscribe(() => this.location.back());
      }
    });
  }

  saveTask(
    taskId: number,
    orderDetailsNew: OrderDetailsNew,
    pdfBlob: Blob,
    onSuccess: () => void
  ): void {
    this.dataService.updateProgressBarSubject(true);
    const formData = new FormData();
    formData.append('file', pdfBlob, `orderform_${taskId}.pdf`);
    if (orderDetailsNew.showAi) {
      orderDetailsNew.tier = 'ai';
      orderDetailsNew.designer = 'ai';
      orderDetailsNew.remainingCorrections = 4;
    }
    formData.append('orderDetails', JSON.stringify(orderDetailsNew));

    this.dataService.post(`/tasks/${taskId}/save`, formData).subscribe({
      next: () => {
        this.dataService.updateCartCount();
        onSuccess();
        this.dialogService.openMessageDialog('Info', 'Item added successfully in Cart.')
          .subscribe(() => window.location.href = '#/dashboard');
      },
      error: (err: any) => {
        this.dialogService.handleError(err, 'Failed to Save, Please try again.');
      }
    });
  }

  editTask(
    taskId: number,
    orderDetailsNew: OrderDetailsNew,
    pdfBlob: Blob,
    onSuccess: () => void
  ): void {
    this.dataService.updateProgressBarSubject(true);
    const formData = new FormData();
    formData.append('file', pdfBlob, `orderform_${taskId}.pdf`);
    if (orderDetailsNew.showAi) {
      orderDetailsNew.tier = 'ai';
      orderDetailsNew.designer = 'ai';
      orderDetailsNew.remainingCorrections = 4;
    }
    formData.append('orderDetails', JSON.stringify(orderDetailsNew));

    this.dataService.post(`/tasks/${taskId}/edit`, formData).subscribe({
      next: () => {
        this.dataService.updateCartCount();
        this.dialogService.openMessageDialog('Info', 'Item updated successfully.')
          .subscribe(() => onSuccess());
      },
      error: (err: any) => {
        this.dialogService.handleError(err, 'Failed to Save, Please try again.');
      }
    });
  }

  deleteTask(taskId: number, onDone: () => void): void {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.delete('/tasks/' + taskId).subscribe({
      next: () => {
        this.dataService.updateProgressBarSubject(false);
        onDone();
      },
      error: () => {
        this.dataService.updateProgressBarSubject(false);
        onDone();
      }
    });
  }
}
